import {
  AddConsultantEventLogSmsMutationVariables,
  GetPersonalInfoCardData,
  useAddConsultantEventLogSmsMutation
} from "@bonliva-crm/graphql";
import { HookProps } from "../utils/hook-props";

export function useAddConsultantEventLogSms(props: HookProps) {
  const [addConsultantEventLogSmsMutation] = useAddConsultantEventLogSmsMutation({
    onError: (error) => {
      console.error(error);
      props.onError && props.onError(error);
    },
    onCompleted: (res) => {
      props.onCompleted && props.onCompleted(res.addConsultantSMSEvent);
    }
  });

  const addConsultantEventLogSms = (args: AddConsultantEventLogSmsMutationVariables) => {
    props.onBeforeCall && props.onBeforeCall();
    addConsultantEventLogSmsMutation({
      variables: args,
      refetchQueries: [GetPersonalInfoCardData.OperationName]
    });
  };

  return { addConsultantEventLogSms };
}
